import { useEffect, useState } from "react";
import { API } from "../lib/api";

const EMPTY = { high_priority: [], priority: [], all_states: [] };
let cache = null;
let pending = null;

export default function usePriorityStates() {
  const [data, setData] = useState(cache || EMPTY);
  useEffect(() => {
    if (cache) return;
    pending = pending || fetch(`${API}/priority-states`).then((r) => r.json()).then((d) => { cache = d; return d; });
    pending.then(setData).catch(() => { pending = null; });
  }, []);
  return data;
}
